import React, { Component } from "react";
import styles from "./styles";
import * as images from "./images";

export default class HomeView extends Component {
  render() {
    return (
      <div style={styles.wrapper}>
        <div>
          <img src={images.mascote} alt="" />
          <h2 style={styles.welcomeText}>Bem vindo(a)!</h2>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/home/view.jsx